import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { getToken } from '../utils/token';
import CowLoader from '../components/CowLoader';

export default function MyVaquitas() {
  const [vaquitas, setVaquitas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVaquitas = async () => {
      try {
        const token = getToken();
        if (!token) {
          alert("No estás logueado.");
          return;
        }

        const res = await api.get('/vaquita/my-vaquitas');
        setVaquitas(res.data);
      } catch (err) {
        console.error('Error al cargar tus vaquitas:', err);
        alert("Error al cargar tus vaquitas.");
      } finally {
        setLoading(false);
      }
    };

    fetchVaquitas();
  }, []);

  if (loading) return <CowLoader text="Cargando tus vaquitas..." />;

  return (
    <div className="my-vaquitas-container">
      <div className="page-header">
        <h1>🐮 Mis Vaquitas</h1>
        <Link to="/create-vaquita" className="create-button-top">+ Nueva</Link>
      </div>

      {vaquitas.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-emoji">🐄</div>
          <div className="empty-state-text">No tienes vaquitas aún. ¡Crea una o únete a una existente!</div>
          <Link to="/create-vaquita" className="create-button">
            Crear mi primera vaquita 🐄
          </Link>
        </div>
      ) : (
        <div className="vaquitas-grid">
          {vaquitas.map(v => (
            <div key={v.id} className="vaquita-card">
              <div className="vaquita-header">
                <div className="vaquita-title">
                  <span>🐮</span>
                  <h3>{v.name}</h3>
                  {v.creatorUserId === v.currentUserId && (
                    <span className="admin-badge">Admin</span>
                  )}
                </div>
                {v.balance !== 0 && (
                  <span className={`balance-badge ${v.balance < 0 ? 'negative' : 'positive'}`}>
                    {v.balance < 0 ? '-' : ''}${Math.abs(v.balance).toLocaleString('es-CL', {maximumFractionDigits:0})} {v.balance < 0 ? '👎' : '👍'}
                  </span>
                )}
              </div>
              <div className="vaquita-body">
                <p className="description">{v.description || "Sin descripción"}</p>
                <div className="vaquita-stats">
                  <div className="stat">
                    <span className="label">Recaudado</span>
                    <span className="value">${(v.totalContributed || 0).toLocaleString('es-CL', {maximumFractionDigits:0})}</span>
                  </div>
                  <div className="stat">
                    <span className="label">Código</span>
                    <span className="value code">{v.inviteCode}</span>
                  </div>
                </div>
                <Link to={`/vaquita/code/${v.inviteCode}`} className="view-details">
                  Ver detalles →
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}


      <style jsx>{`
        .my-vaquitas-container {
          padding: 2rem;
          max-width: 1200px;
          margin: 0 auto;
        }

        .page-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 1.5rem;
        }

        h1 {
          color: var(--text-primary);
          margin: 0;
          font-size: 1.4rem;
        }

        .create-button-top {
          background: var(--accent-color);
          color: white;
          padding: 0.6rem 1.2rem;
          border-radius: 20px;
          text-decoration: none;
          font-size: 0.95rem;
          font-weight: 600;
          white-space: nowrap;
        }

        .vaquitas-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 2rem;
        }

        .vaquita-card {
          background: var(--bg-secondary);
          border-radius: 8px;
          padding: 1.5rem;
          box-shadow: 0 2px 4px var(--shadow-color);
          transition: transform 0.2s, box-shadow 0.2s;
        }

        .vaquita-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 4px 6px var(--shadow-color-hover);
        }

        .vaquita-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1rem;
        }

        .vaquita-title {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .vaquita-title h3 {
          margin: 0;
          font-size: 1.3rem;
          color: var(--text-primary);
        }

        .admin-badge {
          background: var(--accent-color);
          color: white;
          padding: 0.2rem 0.5rem;
          border-radius: 12px;
          font-size: 0.7rem;
          font-weight: normal;
        }

        .balance-badge {
          font-size: 0.7rem;
          padding: 0.2rem 0.5rem;
          border-radius: 12px;
          display: inline-block;
          width: fit-content;
        }

        .balance-badge.negative {
          background: var(--danger-color);
          color: white;
        }

        .balance-badge.positive {
          background: var(--success-color);
          color: white;
        }

        .vaquita-body {
          padding: 1.5rem;
        }

        .description {
          color: var(--text-secondary);
          margin-bottom: 1rem;
          min-height: 3em;
        }

        .vaquita-stats {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
          margin-bottom: 1rem;
        }

        .stat {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 0.5rem;
          background: var(--bg-primary);
          border-radius: 4px;
        }

        .label {
          font-size: 0.9rem;
          color: var(--text-secondary);
        }

        .value {
          font-weight: bold;
          color: var(--accent-color);
        }

        .code {
          font-family: monospace;
        }

        .view-details {
          display: block;
          text-align: center;
          color: var(--accent-color);
          text-decoration: none;
          padding: 0.5rem;
          border-top: 1px solid var(--border-color);
          margin: 1rem -1.5rem -1.5rem;
        }

        .view-details:hover {
          background: var(--bg-primary);
        }

        .floating-create-button {
          position: fixed;
          bottom: 2rem;
          right: 2rem;
          background: var(--accent-color);
          color: white;
          padding: 1rem 2rem;
          border-radius: 50px;
          text-decoration: none;
          box-shadow: 0 2px 8px var(--shadow-color);
          transition: transform 0.2s, box-shadow 0.2s;
        }

        .floating-create-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px var(--shadow-color-hover);
        }

        .loading {
          text-align: center;
          padding: 2rem;
          font-size: 1.2rem;
          color: var(--text-muted);
        }

        .empty-state {
          text-align: center;
          padding: 3rem;
          color: var(--text-muted);
        }

        .empty-state-emoji {
          font-size: 3rem;
          margin-bottom: 1rem;
        }

        .empty-state-text {
          margin-bottom: 2rem;
        }
      `}</style>
    </div>
  );
}
